
import { Vue, Component } from "vue-property-decorator";
import TestimonialsListing from "@/modules/testimonials/components/TestimonialsListing.vue";

@Component({ components: { TestimonialsListing } })
export default class TestimonialsIndex extends Vue {}
